import { useThemeUI, jsx, get } from 'theme-ui';
import Color from 'color';

var useTheme = function useTheme() {
  return useThemeUI().theme;
};

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Card = function Card(props) {
  return jsx("div", _extends({}, props, {
    sx: {
      variant: 'styles.Card'
    }
  }));
};

var _excluded = ["fontSize", "fontFamily", "lineHeight", "fontWeight", "children", "truncate"];
var TypeStyle = function TypeStyle(_ref) {
  var _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 5 : _ref$fontSize,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? 'body' : _ref$fontFamily,
      _ref$lineHeight = _ref.lineHeight,
      lineHeight = _ref$lineHeight === void 0 ? 'body' : _ref$lineHeight,
      _ref$fontWeight = _ref.fontWeight,
      fontWeight = _ref$fontWeight === void 0 ? 'body' : _ref$fontWeight,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? 'Aa' : _ref$children,
      _ref$truncate = _ref.truncate,
      truncate = _ref$truncate === void 0 ? true : _ref$truncate,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return jsx(Card, _extends({}, props, {
    children: children,
    sx: _extends({
      fontFamily: fontFamily,
      fontSize: fontSize,
      lineHeight: lineHeight,
      fontWeight: fontWeight
    }, truncate ? {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    } : {})
  }));
};

var _excluded$1 = ["reverse"];

var getValue = function getValue(fontSize) {
  return typeof fontSize === 'number' ? fontSize + "px" : fontSize;
};

var TypeScale = function TypeScale(_ref) {
  var _ref$reverse = _ref.reverse,
      reverse = _ref$reverse === void 0 ? true : _ref$reverse,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1);

  var theme = useTheme() || {};
  var fontSizeEntries = reverse ? Object.entries(theme.fontSizes || []).reverse() : Object.entries(theme.fontSizes || []);
  return jsx("div", {
    sx: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'baseline'
    }
  }, fontSizeEntries.map(function (_ref2) {
    var key = _ref2[0],
        val = _ref2[1];

    if (!val || typeof val === 'object') {
      // TODO: `theme.fontSizes` can be a deeply nested object.
      // We should either update the types or recursively render here.
      return null;
    }

    return jsx(TypeStyle, _extends({
      key: key,
      fontSize: key,
      sx: {
        mr: 3
      },
      children: getValue(val)
    }, props));
  }));
};

var HeadingStyle = function HeadingStyle(props) {
  return jsx(TypeStyle, _extends({
    fontFamily: "heading",
    fontWeight: "heading",
    lineHeight: "heading"
  }, props));
};

var FontFamily = function FontFamily(_ref) {
  var name = _ref.name;

  var _ref2 = useTheme(),
      fonts = _ref2.fonts;

  return get(fonts, name);
};

var toHex = function toHex(raw) {
  try {
    return Color(raw).hex();
  } catch (e) {
    return;
  }
};

var _excluded$2 = ["color", "name", "size", "label"];
var ColorSwatch = function ColorSwatch(_ref) {
  var color = _ref.color,
      name = _ref.name,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 128 : _ref$size,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? true : _ref$label,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2);

  var _ref2 = useTheme(),
      colors = _ref2.colors;

  var value = get(colors, color);
  return jsx("div", _extends({}, props, {
    title: "" + toHex(value)
  }), jsx("div", {
    sx: {
      width: size,
      height: size,
      bg: color
    }
  }), label && jsx("div", {
    sx: {
      py: 2
    }
  }, name || color));
};

var _excluded$3 = ["colors", "name", "omit", "render", "size"],
    _excluded2 = ["omit", "mode"];

var join = function join() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args.filter(Boolean).join('.');
};

var ColorRow = function ColorRow(_ref) {
  var colors = _ref.colors,
      name = _ref.name,
      _ref$omit = _ref.omit,
      omit = _ref$omit === void 0 ? ['modes'] : _ref$omit,
      render = _ref.render,
      size = _ref.size,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3);

  return jsx("div", null, jsx("div", {
    sx: {
      fontSize: 0,
      display: 'flex',
      flexWrap: 'wrap'
    }
  }, Object.keys(colors).map(function (key) {
    var color = colors[key];
    if (!color || omit.includes(key)) return false;
    var id = join(name, key);

    if (typeof color === 'object') {
      return jsx(ColorRow, _extends({}, props, {
        key: key,
        name: id,
        colors: color,
        size: size,
        omit: omit
      }));
    }

    var swatch = jsx(ColorSwatch, _extends({}, props, {
      key: key,
      name: id,
      color: id,
      size: size,
      sx: {
        m: 2
      }
    }));

    if (typeof render === 'function') {
      return render({
        swatch: swatch,
        color: color,
        key: key,
        name: id
      });
    }

    return swatch;
  })));
};
var ColorPalette = function ColorPalette(_ref2) {
  var omit = _ref2.omit,
      mode = _ref2.mode,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2);

  var theme = useTheme();
  var colors = theme.colors;

  if (mode && colors.modes) {
    colors = colors.modes[mode] || colors;
  }

  return jsx("div", {
    style: {
      marginLeft: -8,
      marginRight: -8
    }
  }, jsx(ColorRow, _extends({}, props, {
    omit: omit,
    colors: colors
  })));
};

var ThemeCard = function ThemeCard(props) {
  return jsx(Card, _extends({}, props, {
    sx: {
      color: 'text',
      bg: 'background'
    }
  }), jsx(TypeStyle, null), jsx(ColorPalette, {
    label: false,
    size: 32
  }));
};

export { ColorPalette, ColorSwatch, FontFamily, HeadingStyle, ThemeCard, TypeScale, TypeStyle, useTheme };
